const SortIcon = ({
  stroke = "#0091D5",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Sort Icon</title>
      <path
        d="M6.96684 4.47998L4.48682 2L2.00684 4.47998"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4.4873 14V2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.0332 11.5195L11.5132 13.9995L13.9932 11.5195"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.5137 2V14" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SortIcon;
